export default __webpack_public_path__ + "static/16-c2133b26f9644cc92cf29f90d236e597.jpg";